import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

window.initHighlightsMarquee = function initHighlightsMarquee() {
  const clientsMarqueeElsArr = document.querySelectorAll('.highlights-marquee');

  if (clientsMarqueeElsArr.length) {
    clientsMarqueeElsArr.forEach((marqueeEl, idx) => {
      const marquee = new CometMarquee(marqueeEl, {
        speed: 40,
        pauseOnHover: true,
        initialShift: window.innerWidth >= 1033,
        pauseOnInvisible: true,
        syncPause: false,
        repeatCount: 5,
        reverse: idx % 2 === 1,
        forceAnimation: window.innerWidth >= 1033,
        forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
        fullWidth: window.innerWidth >= 1033,
      });
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  initHighlightsMarquee();
}
